/**
 * Enum representing the different payment methods available to use when making a payment.
 */
export enum PaymentMethod {
    /**
     * Indicates that a payment is being made using a credit card through Authorize.Net.
     */
    AuthNetAim = 1,
    AuthNetSimdpm = 2,
    CardOnFile = 3,
    CashOrPurchaseOrder = 4,
    /**
     * Indicates that a payment is being made through an invoice with Net 30 payment terms.
     */
    InvoiceNet30 = 5,
    Check = 6,
    ElectronicFundsTransfer = 7,
    Drawdown = 8,
    CreditCard = 9,
}

/**
 * An array of payment methods that can be transitioned from an Invoice Net 30 payment.
 */
export const InvoiceNet30TransitionablePaymentMethods: PaymentMethod[] = [
    PaymentMethod.Check,
    PaymentMethod.ElectronicFundsTransfer,
    PaymentMethod.Drawdown,
    PaymentMethod.CreditCard,
];

export const PaymentMethodLabelMapping: Record<PaymentMethod, string> = {
    [PaymentMethod.AuthNetAim]: 'Authorize.Net AIM - Credit Card',
    [PaymentMethod.AuthNetSimdpm]: 'Unknown',
    [PaymentMethod.CardOnFile]: 'Card On File',
    [PaymentMethod.CashOrPurchaseOrder]: 'Check or PO',
    [PaymentMethod.InvoiceNet30]: 'Invoice Net 30',
    [PaymentMethod.Check]: 'Check',
    [PaymentMethod.ElectronicFundsTransfer]: 'EFT',
    [PaymentMethod.Drawdown]: 'Drawdown',
    [PaymentMethod.CreditCard]: 'Credit Card',
};
